import { render } from "./ConfirmationMessageModal.vue?vue&type=template&id=0edc629a&scoped=true&lang=true"
import script from "./ConfirmationMessageModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationMessageModal.vue?vue&type=script&lang=js"

import "./ConfirmationMessageModal.vue?vue&type=style&index=0&id=0edc629a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edc629a"]])

export default __exports__